/**
 * Normalizes Contentful BaslerID group URNs to the raw group id used in Entra claims.
 * Example: "BaslerID:Group:<id>" + linkType "BaslerID:Group" => "<id>"
 */
export function normalizeBaslerIdGroupUrn(
  urn: string | undefined,
  linkType: string | undefined
): string | undefined {
  if (!urn) {
    return undefined;
  }

  if (!linkType) {
    return urn;
  }

  return urn.replace(`${linkType}:`, '');
}
